// Laufender Arbeits-Timer, persistiert in localStorage. DER Fix für Audit B-1/B-3: weil `startedAt`
// sofort beim Start persistiert wird (und die verstrichene Zeit IMMER aus Wall-Clock − startedAt
// abgeleitet wird, nie im RAM gehalten), überlebt der Lauf Reload/Standby/PWA-Kill/Deploy ohne Verlust.
//
// Modell: GENAU EIN globaler Lauf-Slot (man arbeitet physisch an einem Auftrag zur Zeit). Ein Start
// bei besetztem Slot wird abgelehnt — kein stilles Verwerfen einer laufenden Buchung.

const STORAGE_KEY = 'wf.timer.v1'

export interface RunningTimer {
  orderId: number
  /** Startzeitpunkt als epoch ms. */
  startedAt: number
}

export function getRunningTimer(): RunningTimer | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const v: unknown = JSON.parse(raw)
    if (
      v &&
      typeof v === 'object' &&
      typeof (v as RunningTimer).orderId === 'number' &&
      typeof (v as RunningTimer).startedAt === 'number'
    ) {
      return v as RunningTimer
    }
    return null
  } catch {
    return null
  }
}

function setRunningTimer(timer: RunningTimer | null): void {
  try {
    if (timer) localStorage.setItem(STORAGE_KEY, JSON.stringify(timer))
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Persistenz nicht verfügbar — kein Absturz; der Timer lebt dann nur in dieser Sitzung.
  }
}

/** Startet einen Timer NUR, wenn keiner läuft. Gibt false zurück, wenn der Slot besetzt ist. */
export function startTimer(orderId: number, startedAt: number): boolean {
  if (getRunningTimer()) return false
  setRunningTimer({ orderId, startedAt })
  return true
}

export function clearTimer(): void {
  setRunningTimer(null)
}

export function elapsedSeconds(timer: RunningTimer, now: number): number {
  return Math.max(0, Math.floor((now - timer.startedAt) / 1000))
}
